

export default {
  name: "itemStyle",
  nickname: "项样式",
  desc: "itemStyle",
  type: "object",
  props: {
    color: {
      name: "color",
      nickname: "颜色",
      desc:
        '矩形的颜色。默认从全局调色盘 <a target="__blank" href="https://echarts.apache.org/zh/option.html#color">option.color</a> 获取颜色。',
      eType: "color",
    },
  },
}
